declare global {
  interface Window {
    previewEnvironment: string | null;
  }
}

const STORAGE_KEY = 'previewEnvironment';

function readRoutingNameFromUrl(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get('x-ms-routing-name') || params.get('preview-env');
}

export function initPreviewEnvironment(): string | null {
  const routingName = readRoutingNameFromUrl();
  if (routingName) {
    localStorage.setItem(STORAGE_KEY, routingName);
  }
  const value = localStorage.getItem(STORAGE_KEY);
  window['previewEnvironment'] = value;
  return value;
}

export function exitBackendPreview(): void {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.delete('x-ms-routing-name');
  currentUrl.searchParams.delete('preview-env');
  localStorage.removeItem(STORAGE_KEY);
  window.location.href = currentUrl.toString();
}
